export var setNotification = function setNotification(notificationProperties) {
  return function (_ref) {
    var setState = _ref.setState;
    setState({
      notification: {
        type: notificationProperties.type
      }
    });
  };
};
export var resetNotification = function resetNotification() {
  return function (_ref2) {
    var setState = _ref2.setState;
    setState({
      notification: null
    });
  };
};